import { render } from "./BlogZircVenConsumption.vue?vue&type=template&id=1ab28767"
import script from "./BlogZircVenConsumption.vue?vue&type=script&lang=js"
export * from "./BlogZircVenConsumption.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__